import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { getTimeDuration } from '@libs';
import { Points, textSize } from '@styles';

export const TimeRanges = ({ time, locale }) => {
  return <Container>{getTimeDuration(time, locale)}</Container>;
};

const Container = styled.div`
  padding-left: 21px;
  background-image: url('/images/help/time-ranges.png');
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 16px;
  ${textSize('description')};
  color: ${Colors.second_gray};
  margin-top: 5px;

  @media ${Points.fullhd} {
    margin-top: 10px;
  }
`;
